(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './androidx-lifecycle-lifecycle-common.js', './kotlin-kotlin-stdlib.js', './androidx-savedstate-savedstate.js', './androidx-lifecycle-lifecycle-viewmodel.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./androidx-lifecycle-lifecycle-common.js'), require('./kotlin-kotlin-stdlib.js'), require('./androidx-savedstate-savedstate.js'), require('./androidx-lifecycle-lifecycle-viewmodel.js'));
  else {
    if (typeof globalThis['androidx-lifecycle-lifecycle-common'] === 'undefined') {
      throw new Error("Error loading module 'androidx-lifecycle-lifecycle-viewmodel-savedstate'. Its dependency 'androidx-lifecycle-lifecycle-common' was not found. Please, check whether 'androidx-lifecycle-lifecycle-common' is loaded prior to 'androidx-lifecycle-lifecycle-viewmodel-savedstate'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'androidx-lifecycle-lifecycle-viewmodel-savedstate'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'androidx-lifecycle-lifecycle-viewmodel-savedstate'.");
    }
    if (typeof globalThis['androidx-savedstate-savedstate'] === 'undefined') {
      throw new Error("Error loading module 'androidx-lifecycle-lifecycle-viewmodel-savedstate'. Its dependency 'androidx-savedstate-savedstate' was not found. Please, check whether 'androidx-savedstate-savedstate' is loaded prior to 'androidx-lifecycle-lifecycle-viewmodel-savedstate'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-viewmodel'] === 'undefined') {
      throw new Error("Error loading module 'androidx-lifecycle-lifecycle-viewmodel-savedstate'. Its dependency 'androidx-lifecycle-lifecycle-viewmodel' was not found. Please, check whether 'androidx-lifecycle-lifecycle-viewmodel' is loaded prior to 'androidx-lifecycle-lifecycle-viewmodel-savedstate'.");
    }
    globalThis['androidx-lifecycle-lifecycle-viewmodel-savedstate'] = factory(typeof globalThis['androidx-lifecycle-lifecycle-viewmodel-savedstate'] === 'undefined' ? {} : globalThis['androidx-lifecycle-lifecycle-viewmodel-savedstate'], globalThis['androidx-lifecycle-lifecycle-common'], globalThis['kotlin-kotlin-stdlib'], globalThis['androidx-savedstate-savedstate'], globalThis['androidx-lifecycle-lifecycle-viewmodel']);
  }
}(function (_, kotlin_androidx_lifecycle_lifecycle_common, kotlin_kotlin, kotlin_androidx_savedstate_savedstate, kotlin_androidx_lifecycle_lifecycle_viewmodel) {
  'use strict';
  //region block: imports
  var State_INITIALIZED_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.m;
  var State_CREATED_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.k;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var lazy = kotlin_kotlin.$_$.to;
  var emptyMap = kotlin_kotlin.$_$.d9;
  var toMutableMap = kotlin_kotlin.$_$.rc;
  var SavedState = kotlin_androidx_savedstate_savedstate.$_$.b;
  var _SavedStateWriter___init__impl__99cr38 = kotlin_androidx_savedstate_savedstate.$_$.h;
  var SavedStateWriter__putAll_impl_no0lvi = kotlin_androidx_savedstate_savedstate.$_$.i;
  var _SavedStateReader___init__impl__k2stzo = kotlin_androidx_savedstate_savedstate.$_$.c;
  var SavedStateReader__isEmpty_impl_ep4h1z = kotlin_androidx_savedstate_savedstate.$_$.f;
  var SavedStateWriter__putSavedState_impl_5xy7ov = kotlin_androidx_savedstate_savedstate.$_$.j;
  var protoOf = kotlin_kotlin.$_$.eh;
  var SavedStateReader__contains_impl_ig4u69 = kotlin_androidx_savedstate_savedstate.$_$.d;
  var SavedStateReader__getSavedStateOrNull_impl_pv2mts = kotlin_androidx_savedstate_savedstate.$_$.e;
  var SavedStateWriter__remove_impl_9y9m5w = kotlin_androidx_savedstate_savedstate.$_$.k;
  var SavedStateProvider = kotlin_androidx_savedstate_savedstate.$_$.a;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var Event_ON_CREATE_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.e;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var LifecycleEventObserver = kotlin_androidx_lifecycle_lifecycle_common.$_$.a;
  var ViewModel = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.e;
  var ViewModel_init_$Init$ = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.k;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var Companion_getInstance = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.i;
  var getKClass = kotlin_kotlin.$_$.si;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var Factory = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.c;
  var Companion_instance = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.g;
  var equals = kotlin_kotlin.$_$.sf;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var isInterface = kotlin_kotlin.$_$.rg;
  var hashCode = kotlin_kotlin.$_$.bg;
  var toMap = kotlin_kotlin.$_$.nc;
  var ClassCastException = kotlin_kotlin.$_$.zm;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var SavedStateReader__toMap_impl_49zebr = kotlin_androidx_savedstate_savedstate.$_$.g;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var create = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.b;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(SavedStateHandlesProvider, 'SavedStateHandlesProvider', VOID, VOID, [SavedStateProvider]);
  initMetadataForClass(SavedStateHandleAttacher, 'SavedStateHandleAttacher', VOID, VOID, [LifecycleEventObserver]);
  initMetadataForClass(SavedStateHandlesVM, 'SavedStateHandlesVM', SavedStateHandlesVM, ViewModel);
  initMetadataForClass(SAVED_STATE_REGISTRY_OWNER_KEY$$inlined$Key$1);
  initMetadataForClass(VIEW_MODEL_STORE_OWNER_KEY$$inlined$Key$1);
  initMetadataForClass(DEFAULT_ARGS_KEY$$inlined$Key$1);
  initMetadataForClass(savedStateHandlesVM$1, VOID, VOID, VOID, [Factory]);
  initMetadataForClass(sam$androidx_savedstate_SavedStateRegistry_SavedStateProvider$0, 'sam$androidx_savedstate_SavedStateRegistry_SavedStateProvider$0', VOID, VOID, [SavedStateProvider, FunctionAdapter]);
  initMetadataForClass(SavedStateHandleImpl, 'SavedStateHandleImpl', SavedStateHandleImpl);
  initMetadataForCompanion(Companion);
  initMetadataForClass(SavedStateHandle, 'SavedStateHandle', SavedStateHandle_init_$Create$_0);
  initMetadataForClass(SavedStateViewModelFactory, 'SavedStateViewModelFactory', SavedStateViewModelFactory, VOID, [Factory]);
  //endregion
  function get_SAVED_STATE_REGISTRY_OWNER_KEY() {
    _init_properties_SavedStateHandleSupport_kt__nxqisr();
    return SAVED_STATE_REGISTRY_OWNER_KEY;
  }
  var SAVED_STATE_REGISTRY_OWNER_KEY;
  function get_VIEW_MODEL_STORE_OWNER_KEY() {
    _init_properties_SavedStateHandleSupport_kt__nxqisr();
    return VIEW_MODEL_STORE_OWNER_KEY;
  }
  var VIEW_MODEL_STORE_OWNER_KEY;
  function get_DEFAULT_ARGS_KEY() {
    _init_properties_SavedStateHandleSupport_kt__nxqisr();
    return DEFAULT_ARGS_KEY;
  }
  var DEFAULT_ARGS_KEY;
  function enableSavedStateHandles(_this__u8e3s4) {
    _init_properties_SavedStateHandleSupport_kt__nxqisr();
    var currentState = _this__u8e3s4.w7m().v70();
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(currentState.equals(State_INITIALIZED_getInstance()) || currentState.equals(State_CREATED_getInstance()))) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    if (_this__u8e3s4.i7p().t7m('androidx.lifecycle.internal.SavedStateHandlesProvider') == null) {
      var provider = new SavedStateHandlesProvider(_this__u8e3s4.i7p(), _this__u8e3s4);
      _this__u8e3s4.i7p().s7m('androidx.lifecycle.internal.SavedStateHandlesProvider', provider);
      _this__u8e3s4.w7m().t70(new SavedStateHandleAttacher(provider));
    }
  }
  function _get_viewModel__fokd3h($this) {
    var tmp0 = $this.p8r_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('viewModel', 1, tmp, SavedStateHandlesProvider$_get_viewModel_$ref_aibsd2(), null);
    return tmp0.u1();
  }
  function SavedStateHandlesProvider$viewModel$delegate$lambda($viewModelStoreOwner) {
    return function () {
      return get_savedStateHandlesVM($viewModelStoreOwner);
    };
  }
  function SavedStateHandlesProvider$_get_viewModel_$ref_aibsd2() {
    return constructCallableReference(function (p0) {
      return _get_viewModel__fokd3h(p0);
    }, 1, 0, 45);
  }
  function SavedStateHandlesProvider(savedStateRegistry, viewModelStoreOwner) {
    this.m8r_1 = savedStateRegistry;
    this.n8r_1 = false;
    this.o8r_1 = null;
    var tmp = this;
    tmp.p8r_1 = lazy(SavedStateHandlesProvider$viewModel$delegate$lambda(viewModelStoreOwner));
  }
  protoOf(SavedStateHandlesProvider).z7m = function () {
    // Inline function 'androidx.savedstate.savedState' call
    var initialState = emptyMap();
    var copiedState = toMutableMap(initialState);
    // Inline function 'kotlin.apply' call
    var this_0 = new SavedState(copiedState);
    // Inline function 'androidx.savedstate.write' call
    var $this$savedState = _SavedStateWriter___init__impl__99cr38(this_0);
    var tmp0_safe_receiver = this.o8r_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      SavedStateWriter__putAll_impl_no0lvi($this$savedState, tmp0_safe_receiver);
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = _get_viewModel__fokd3h(this).r8r_1.s1().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlin.collections.component1' call
      var key = element.t1();
      // Inline function 'kotlin.collections.component2' call
      var handle = element.u1();
      var savedState = handle.t8r().z7m();
      // Inline function 'androidx.savedstate.read' call
      var $this$read = _SavedStateReader___init__impl__k2stzo(savedState);
      if (!SavedStateReader__isEmpty_impl_ep4h1z($this$read)) {
        SavedStateWriter__putSavedState_impl_5xy7ov($this$savedState, key, savedState);
      }
    }
    this.n8r_1 = false;
    return this_0;
  };
  protoOf(SavedStateHandlesProvider).u8r = function () {
    if (!this.n8r_1) {
      var newState = this.m8r_1.r7m('androidx.lifecycle.internal.SavedStateHandlesProvider');
      var tmp = this;
      // Inline function 'androidx.savedstate.savedState' call
      var initialState = emptyMap();
      var copiedState = toMutableMap(initialState);
      // Inline function 'kotlin.apply' call
      var this_0 = new SavedState(copiedState);
      // Inline function 'androidx.savedstate.write' call
      var $this$savedState = _SavedStateWriter___init__impl__99cr38(this_0);
      var tmp0_safe_receiver = this.o8r_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        SavedStateWriter__putAll_impl_no0lvi($this$savedState, tmp0_safe_receiver);
      }
      if (newState == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        SavedStateWriter__putAll_impl_no0lvi($this$savedState, newState);
      }
      tmp.o8r_1 = this_0;
      this.n8r_1 = true;
      _get_viewModel__fokd3h(this);
    }
  };
  protoOf(SavedStateHandlesProvider).r7m = function (key) {
    this.u8r();
    var tmp0_elvis_lhs = this.o8r_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var state = tmp;
    // Inline function 'androidx.savedstate.read' call
    var $this$read = _SavedStateReader___init__impl__k2stzo(state);
    if (!SavedStateReader__contains_impl_ig4u69($this$read, key))
      return null;
    // Inline function 'androidx.savedstate.read' call
    var $this$read_0 = _SavedStateReader___init__impl__k2stzo(state);
    var tmp0_elvis_lhs_0 = SavedStateReader__getSavedStateOrNull_impl_pv2mts($this$read_0, key);
    var tmp_0;
    if (tmp0_elvis_lhs_0 == null) {
      // Inline function 'androidx.savedstate.savedState' call
      var initialState = emptyMap();
      var copiedState = toMutableMap(initialState);
      // Inline function 'kotlin.apply' call
      var this_0 = new SavedState(copiedState);
      // Inline function 'androidx.savedstate.write' call
      _SavedStateWriter___init__impl__99cr38(this_0);
      tmp_0 = this_0;
    } else {
      tmp_0 = tmp0_elvis_lhs_0;
    }
    var result = tmp_0;
    // Inline function 'androidx.savedstate.write' call
    var $this$write = _SavedStateWriter___init__impl__99cr38(state);
    SavedStateWriter__remove_impl_9y9m5w($this$write, key);
    // Inline function 'androidx.savedstate.read' call
    var $this$read_1 = _SavedStateReader___init__impl__k2stzo(state);
    if (SavedStateReader__isEmpty_impl_ep4h1z($this$read_1)) {
      this.o8r_1 = null;
    }
    return result;
  };
  function SavedStateHandleAttacher(provider) {
    this.v8r_1 = provider;
  }
  protoOf(SavedStateHandleAttacher).j70 = function (source, event) {
    // Inline function 'kotlin.check' call
    if (!event.equals(Event_ON_CREATE_getInstance())) {
      var message = 'Next event must be ON_CREATE, it was ' + event.toString();
      throw IllegalStateException_init_$Create$(toString(message));
    }
    source.w7m().u70(this);
    this.v8r_1.u8r();
  };
  function SavedStateHandlesVM() {
    ViewModel_init_$Init$(this);
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.r8r_1 = LinkedHashMap_init_$Create$();
  }
  function get_savedStateHandlesVM(_this__u8e3s4) {
    _init_properties_SavedStateHandleSupport_kt__nxqisr();
    var tmp = Companion_getInstance();
    return tmp.h8r(_this__u8e3s4, new savedStateHandlesVM$1()).l8r('androidx.lifecycle.internal.SavedStateHandlesVM', getKClass(SavedStateHandlesVM));
  }
  function createSavedStateHandle(_this__u8e3s4) {
    _init_properties_SavedStateHandleSupport_kt__nxqisr();
    var tmp0_elvis_lhs = _this__u8e3s4.g8q(get_SAVED_STATE_REGISTRY_OWNER_KEY());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('CreationExtras must have a value by `SAVED_STATE_REGISTRY_OWNER_KEY`');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var savedStateRegistryOwner = tmp;
    var tmp1_elvis_lhs = _this__u8e3s4.g8q(get_VIEW_MODEL_STORE_OWNER_KEY());
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('CreationExtras must have a value by `VIEW_MODEL_STORE_OWNER_KEY`');
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var viewModelStateRegistryOwner = tmp_0;
    var defaultArgs = _this__u8e3s4.g8q(get_DEFAULT_ARGS_KEY());
    var tmp2_elvis_lhs = _this__u8e3s4.g8q(Companion_getInstance().w8q_1);
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('CreationExtras must have a value by `VIEW_MODEL_KEY`');
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var key = tmp_1;
    return createSavedStateHandle_0(savedStateRegistryOwner, viewModelStateRegistryOwner, key, defaultArgs);
  }
  function createSavedStateHandle_0(savedStateRegistryOwner, viewModelStoreOwner, key, defaultArgs) {
    _init_properties_SavedStateHandleSupport_kt__nxqisr();
    var provider = get_savedStateHandlesProvider(savedStateRegistryOwner);
    var viewModel = get_savedStateHandlesVM(viewModelStoreOwner);
    var tmp0_elvis_lhs = viewModel.r8r_1.w2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = Companion_instance_0.w8r(provider.r7m(key), defaultArgs);
      // Inline function 'kotlin.collections.set' call
      viewModel.r8r_1.z2(key, this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function get_savedStateHandlesProvider(_this__u8e3s4) {
    _init_properties_SavedStateHandleSupport_kt__nxqisr();
    var tmp = _this__u8e3s4.i7p().t7m('androidx.lifecycle.internal.SavedStateHandlesProvider');
    var tmp0_elvis_lhs = tmp instanceof SavedStateHandlesProvider ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$("enableSavedStateHandles() wasn't called prior to createSavedStateHandle() call");
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
  function SAVED_STATE_REGISTRY_OWNER_KEY$$inlined$Key$1() {
  }
  function VIEW_MODEL_STORE_OWNER_KEY$$inlined$Key$1() {
  }
  function DEFAULT_ARGS_KEY$$inlined$Key$1() {
  }
  function savedStateHandlesVM$1() {
  }
  protoOf(savedStateHandlesVM$1).e8r = function (modelClass, extras) {
    var tmp = new SavedStateHandlesVM();
    return tmp instanceof ViewModel ? tmp : THROW_CCE();
  };
  var properties_initialized_SavedStateHandleSupport_kt_6hqgvh;
  function _init_properties_SavedStateHandleSupport_kt__nxqisr() {
    if (!properties_initialized_SavedStateHandleSupport_kt_6hqgvh) {
      properties_initialized_SavedStateHandleSupport_kt_6hqgvh = true;
      // Inline function 'androidx.lifecycle.viewmodel.Companion.Key' call
      SAVED_STATE_REGISTRY_OWNER_KEY = new SAVED_STATE_REGISTRY_OWNER_KEY$$inlined$Key$1();
      // Inline function 'androidx.lifecycle.viewmodel.Companion.Key' call
      VIEW_MODEL_STORE_OWNER_KEY = new VIEW_MODEL_STORE_OWNER_KEY$$inlined$Key$1();
      // Inline function 'androidx.lifecycle.viewmodel.Companion.Key' call
      DEFAULT_ARGS_KEY = new DEFAULT_ARGS_KEY$$inlined$Key$1();
    }
  }
  function sam$androidx_savedstate_SavedStateRegistry_SavedStateProvider$0(function_0) {
    this.x8r_1 = function_0;
  }
  protoOf(sam$androidx_savedstate_SavedStateRegistry_SavedStateProvider$0).z7m = function () {
    return this.x8r_1();
  };
  protoOf(sam$androidx_savedstate_SavedStateRegistry_SavedStateProvider$0).q3 = function () {
    return this.x8r_1;
  };
  protoOf(sam$androidx_savedstate_SavedStateRegistry_SavedStateProvider$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, SavedStateProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_savedstate_SavedStateRegistry_SavedStateProvider$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function SavedStateHandleImpl$savedStateProvider$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = toMap(this$0.b8s_1).s1().t();
      while (_iterator__ex2g4s.u()) {
        var _destruct__k2r9zo = _iterator__ex2g4s.v();
        // Inline function 'kotlin.collections.component1' call
        var key = _destruct__k2r9zo.t1();
        // Inline function 'kotlin.collections.component2' call
        var mutableFlow = _destruct__k2r9zo.u1();
        this$0.d8s(key, mutableFlow.u1());
      }
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_0 = toMap(this$0.z8r_1).s1().t();
      while (_iterator__ex2g4s_0.u()) {
        var _destruct__k2r9zo_0 = _iterator__ex2g4s_0.v();
        // Inline function 'kotlin.collections.component1' call
        var key_0 = _destruct__k2r9zo_0.t1();
        // Inline function 'kotlin.collections.component2' call
        var provider = _destruct__k2r9zo_0.u1();
        this$0.d8s(key_0, provider.z7m());
      }
      // Inline function 'androidx.savedstate.savedState' call
      var initialState = this$0.y8r_1;
      var copiedState = toMutableMap(initialState);
      // Inline function 'kotlin.apply' call
      var this_0 = new SavedState(copiedState);
      // Inline function 'androidx.savedstate.write' call
      _SavedStateWriter___init__impl__99cr38(this_0);
      return this_0;
    };
  }
  function SavedStateHandleImpl(initialState) {
    initialState = initialState === VOID ? emptyMap() : initialState;
    this.y8r_1 = toMutableMap(initialState);
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.z8r_1 = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.a8s_1 = LinkedHashMap_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.b8s_1 = LinkedHashMap_init_$Create$();
    var tmp_2 = this;
    var tmp_3 = SavedStateHandleImpl$savedStateProvider$lambda(this);
    tmp_2.c8s_1 = new sam$androidx_savedstate_SavedStateRegistry_SavedStateProvider$0(tmp_3);
  }
  protoOf(SavedStateHandleImpl).fun_savedStateProvider = function () {
    return this.c8s_1;
  };
  protoOf(SavedStateHandleImpl).e8s = function (key) {
    var tmp;
    try {
      var tmp0_safe_receiver = this.b8s_1.w2(key);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u1();
      tmp = tmp1_elvis_lhs == null ? this.y8r_1.w2(key) : tmp1_elvis_lhs;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof ClassCastException) {
        var e = $p;
        this.f8s(key);
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(SavedStateHandleImpl).d8s = function (key, value) {
    // Inline function 'kotlin.collections.set' call
    this.y8r_1.z2(key, value);
    var tmp0_safe_receiver = this.a8s_1.w2(key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.s21(value);
    }
    var tmp1_safe_receiver = this.b8s_1.w2(key);
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.s21(value);
    }
  };
  protoOf(SavedStateHandleImpl).f8s = function (key) {
    var latestValue = this.y8r_1.a3(key);
    this.a8s_1.a3(key);
    this.b8s_1.a3(key);
    return latestValue;
  };
  function SavedStateHandle_init_$Init$(initialState, $this) {
    SavedStateHandle.call($this);
    $this.s8r_1 = new SavedStateHandleImpl(initialState);
    return $this;
  }
  function SavedStateHandle_init_$Create$(initialState) {
    return SavedStateHandle_init_$Init$(initialState, objectCreate(protoOf(SavedStateHandle)));
  }
  function SavedStateHandle_init_$Init$_0($this) {
    SavedStateHandle.call($this);
    $this.s8r_1 = new SavedStateHandleImpl();
    return $this;
  }
  function SavedStateHandle_init_$Create$_0() {
    return SavedStateHandle_init_$Init$_0(objectCreate(protoOf(SavedStateHandle)));
  }
  function Companion() {
  }
  protoOf(Companion).w8r = function (restoredState, defaultState) {
    var initialState = restoredState == null ? defaultState : restoredState;
    if (initialState == null)
      return SavedStateHandle_init_$Create$_0();
    // Inline function 'androidx.savedstate.read' call
    var $this$read = _SavedStateReader___init__impl__k2stzo(initialState);
    var tmp$ret$0 = SavedStateReader__toMap_impl_49zebr($this$read);
    return SavedStateHandle_init_$Create$(tmp$ret$0);
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  protoOf(SavedStateHandle).t8r = function () {
    return this.s8r_1.fun_savedStateProvider();
  };
  protoOf(SavedStateHandle).e8s = function (key) {
    return this.s8r_1.e8s(key);
  };
  protoOf(SavedStateHandle).d8s = function (key, value) {
    return this.s8r_1.d8s(key, value);
  };
  function SavedStateHandle() {
  }
  function SavedStateViewModelFactory() {
  }
  protoOf(SavedStateViewModelFactory).e8r = function (modelClass, extras) {
    return create.call(this, modelClass, extras);
  };
  //region block: init
  Companion_instance_0 = new Companion();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = get_SAVED_STATE_REGISTRY_OWNER_KEY;
  _.$_$.b = SavedStateHandle;
  _.$_$.c = SavedStateViewModelFactory;
  _.$_$.d = get_VIEW_MODEL_STORE_OWNER_KEY;
  _.$_$.e = createSavedStateHandle;
  _.$_$.f = enableSavedStateHandles;
  //endregion
  return _;
}));

//# sourceMappingURL=androidx-lifecycle-lifecycle-viewmodel-savedstate.js.map
